// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__14HiC","requiredAsterisk":"Info_requiredAsterisk__Xd6Ww"};